import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import $store from '@/store'
import StrUtils from '@/utils/StrUtils'

export class PrintTemplateUtil {
  /**
   * BOOKING
   * @param job
   * @param data
   */
  static async buildPrintDataByBooking(job, data) {
    // 主票 且是 BCF
    if (!(job.masterFlag && job.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE_FCL.code)) {
      await this.setRequestUuid(job, data)
    } else {
      data.jobuuid = job.uuid
      data.JOB_UUID = job.uuid
      data.REQUEST_UUID = ''
    }
  }

  static async setRequestUuid(job, data) {
    // 取 特殊要求的 uuid
    if (job.satisfiedRequests) {
      if (job.customerId) {
        const company = await Company.getCompanyById(job.customerId)
        if (company) {
          const customer = await Company.loadCustomer(company.uuid).then(data => data.length > 0 ? data[0] : null)
          if (customer) {
            const allSpecialRequests = await new Customer(customer).getSpecialRequests()
            if (allSpecialRequests && allSpecialRequests.length > 0) {
              const specialRequests = job.satisfiedRequests.split(',').map(item => item.trim())
              const specialRequestUuids = []
              for (const item of allSpecialRequests) {
                if (item.request && specialRequests.includes(item.request.trim())) {
                  specialRequestUuids.push(item.uuid)
                }
              }
              data.REQUEST_UUID = (specialRequestUuids.length === 0 ? '' : specialRequestUuids)
            }
          }
        }
      }
    }
  }

  /**
   * MANIFESTINFO
   * @param manifestInfo
   * @param data
   */
  static async buildPrintDataByManifestInfo(manifestInfo, data) {
    data.MANIFEST_INFO_UUID = manifestInfo.uuid
  }

  /**
   * MBL
   * @param mbl
   * @param data
   */
  static async buildPrintDataByMbl(mbl, data) {
    data.cargoDocUuid = mbl.uuid
    data.DOC_UUID = mbl.uuid
  }

  /**
   * LOCALSERVICE
   * @param job
   * @param data
   */
  static async buildPrintDataByLocalService(job, data) {
    data.jobuuid = job.uuid
    data.JOB_UUID = job.uuid
    data.truckinguuid = null
    data.USER_ID = $store.getters.userId
  }

  /**
   * FBA_INTERNAL_WAREHOUSE
   * @param warehouse
   * @param data
   */
  static async buildPrintDataByFbaInternalWarehouse(warehouse, data) {
    data.WAREHOUSE_UUID = [warehouse.uuid]
    data.USER_ID = $store.getters.userId
  }

  /**
   * FBA_OVERSEA_WAREHOUSE
   * @param warehouse
   * @param data
   */
  static async buildPrintDataByFbaOverseaWarehouse(warehouse, data) {
    data.WAREHOUSE_UUID = [warehouse.uuid]
    data.USER_ID = $store.getters.userId
  }

  /**
   * POD_TRUCKING
   * @param job
   * @param dischargingTrucking
   * @param data
   */
  static async buildPrintDataByPodTrucking(job, dischargingTrucking, data) {
    const truckingUuids = Array.from(dischargingTrucking, p => p.uuid).join(',')
    data.TRUCKING_UUID = StrUtils.isEmpty(truckingUuids) ? null : truckingUuids
    data.JOB_UUID = job.uuid
  }

  /**
   * SIMBL
   * @param mbl
   * @param data
   */
  static async buildPrintDataBySimbl(mbl, data) {
    data.cargoDocUuid = mbl.uuid
    data.DOC_UUID = mbl.uuid
  }

  /**
   * SIHBL
   * @param mbl
   * @param data
   */
  static async buildPrintDataBySihbl(job, hbl, data) {
    data.jobuuid = job.uuid
    data.cargoDocUuid = hbl.uuid
    data.DOC_UUID = hbl.uuid
    data.printCallBackUrl = 'services/printExec/sop/update/print_hbl?jobKey=' + encodeURIComponent(job.uuid)
  }

  /**
   * SIPO
   * @param mbl
   * @param data
   */
  static async buildPrintDataBySipo(job, poList, data) {
    data.jobuuid = job.uuid
    data.job = poList
  }

  /**
   * AEMAWB
   * @param mbl
   * @param data
   */
  static async buildPrintDataByAemawb(job, mawb, data) {
    data.JOB_UUID = job.uuid
    data.cargoDocUuid = mawb.uuid
    data.DOC_UUID = mawb.uuid
  }

  /**
   * AEHAWB
   * @param mbl
   * @param data
   */
  static async buildPrintDataByAehawb(job, hawb, data) {
    data.JOB_UUID = job.uuid
    data.cargoDocUuid = hawb.uuid
    data.DOC_UUID = hawb.uuid
  }

  /**
   * AIHAWB
   * @param mbl
   * @param data
   */
  static async buildPrintDataByAihawb(job, hawb, data) {
    data.JOB_UUID = job.uuid
    data.cargoDocUuid = hawb.uuid
    data.DOC_UUID = hawb.uuid
  }

  /**
   * BOOKING_RE
   * @param job
   * @param data
   */
  static async buildPrintDataByBookingRe(job, data) {
    // 主票 且是 BCF
    if (!job.masterFlag) {
      await this.setRequestUuid(job, data)
    } else {
      data.jobuuid = job.uuid
      data.JOB_UUID = job.uuid
      data.REQUEST_UUID = ''
    }
  }
}
